import type { ReactNode } from 'react';

export const symbol_male: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M800-770v160q0 13-8.5 21.5T770-580q-13 0-21.5-8.5T740-610v-87L556-514q21 29 32.5 63.5T600-380q0 92-64 156t-156 64q-92 0-156-64t-64-156q0-92 64-156t156-64q36 0 70 11.5t63 32.5l184-184h-87q-13 0-21.5-8.5T580-770q0-13 8.5-21.5T610-800h160q13 0 21.5 8.5T800-770ZM267-493q-47 47-47 113t47 113q47 47 113 47t113-47q47-47 47-113t-47-113q-47-47-113-47t-113 47Z"
		/>
	</svg>
);
